// extracted by mini-css-extract-plugin
export default {"spinner-overlay":"Spinner_spinner-overlay__lIFnF","spinner":"Spinner_spinner__Qz7DP","spin":"Spinner_spin__CnP0Z"};